import { Routes } from '@angular/router';
import {
  BreadCrumbRouteConfig,
  RenderInterfaceGuard,
  Utils
} from 'viggo-sistemas-core-web';
export const routesAdminVendas: Routes = [
  {
    path: 'pedidos',
    canActivate: [RenderInterfaceGuard],
    loadChildren: () =>
      import('@modules/pedidos/pedidos.module').then(m => m.PedidosModule),
    data: {
      module: 'VEN_PEDIDO',
      breadcrumbMenu: Utils.getBreadcrumbMenu('VENDAS'),
      breadcrumb: {
        label: 'Pedidos',
        icon: 'mdi mdi-receipt-text-outline'
      } as BreadCrumbRouteConfig
    }
  },

  {
    path: 'pdv',
    canActivate: [RenderInterfaceGuard],
    loadChildren: () =>
      import('@modules/pedido-pdv/pedido-pdv.module').then(
        m => m.PedidoPdvModule
      ),
    data: {
      module: 'VEN_PDV',
      breadcrumbMenu: Utils.getBreadcrumbMenu('VENDAS'),
      breadcrumb: {
        label: 'Ponto de vendas',
        icon: 'pi pi-fw pi-desktop'
      } as BreadCrumbRouteConfig
    }
  },
  {
    path: 'registros_caixa',
    canActivate: [RenderInterfaceGuard],
    loadChildren: () =>
      import('@modules/registros_caixa/registros_caixa.module').then(
        m => m.RegistroCaixaModule
      ),
    data: {
      module: 'VEN_CAIXA',
      breadcrumbMenu: Utils.getBreadcrumbMenu('FINANCEIRO'),
      breadcrumb: {
        label: 'Registros dos caixas',
        icon: 'pi pi-fw pi-money-bill'
      } as BreadCrumbRouteConfig
    }
  },
  {
    path: 'terminais',
    canActivate: [RenderInterfaceGuard],
    loadChildren: () =>
      import('@modules/terminal/terminal.module').then(m => m.TerminalModule),
    data: {
      module: 'VEN_TERMINAL',
      breadcrumbMenu: Utils.getBreadcrumbMenu('CONFIGURACOES','VENDAS'),
      breadcrumb: {
        label: 'Terminais',
        icon: 'pi pi-fw pi-desktop'
      } as BreadCrumbRouteConfig
    }
  },
  {
    path: 'pre-pedidos',
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'VEN_PRE_PEDIDO',
      breadcrumbMenu: Utils.getBreadcrumbMenu('VENDAS'),
      preload: false,
      breadcrumb: {
        label: 'Pré pedidos',
        icon: 'mdi mdi-receipt-text-clock-outline'
      } as BreadCrumbRouteConfig
    },
    loadChildren: () =>
      import('@app/modules/pre-pedido/pre-pedido.module').then(
        m => m.PrePedidoModule
      )
  },
  {
    path: 'pedidos-integracao',
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'VEN_PEDIDO_INTEGRACAO',
      breadcrumbMenu: Utils.getBreadcrumbMenu('VENDAS'),
      preload: false,
      breadcrumb: {
        label: 'Pedidos integração',
        icon: 'mdi mdi-receipt-text-check-outline'
      } as BreadCrumbRouteConfig
    },
    loadChildren: () =>
      import('@app/modules/pedidos_integracao/pedidos_integracao.module').then(
        m => m.PedidosIntegracaoModule
      )
  }
];
